export default {
  StateFormField__ARIA: "State",
  StateFormField__LABEL: "State",
  StateFormField__NO_MATCH_FOUND: "No match found",
};
